import { Button } from '@massilia/ui'
import { Link, useNavigate } from '@tanstack/react-router'
import { CopyIcon, PhoneIcon, UserRound } from 'lucide-react'

import { useAgencyPhone } from '@/hooks/use-agency-phone'
import { useAuthStore } from '@/stores/auth.store'

export function BlueHeader({ showPhoneButton = true }: { showPhoneButton?: boolean }) {
  const navigate = useNavigate()
  const { isAuthenticated, user } = useAuthStore()
  const agencyPhone = useAgencyPhone()

  return (
    <div className="flex justify-between px-4 py-3 md:px-32 md:py-4">
      <Link href="https://wp.massiliavoyages.fr/" to=".">
        <img alt="logo" className="h-7 md:h-9" src="/logos/massilia-logo-text-white.png" />
      </Link>
      <div className="flex items-center gap-2">
        {showPhoneButton && (
          <>
            {/* Mobile: direct tel link */}
            <a
              className="flex h-10 items-center gap-2 rounded-lg bg-[#1D95AD] px-3 md:hidden"
              href={`tel:${agencyPhone.replace(/\s/g, '')}`}
            >
              <PhoneIcon className="size-4 text-white" />
              <span className="text-sm font-medium text-white">{agencyPhone}</span>
            </a>

            {/* Desktop: hover to reveal with copy */}
            <div className="group relative hidden h-10 w-44 cursor-default items-center gap-2 overflow-hidden rounded-lg bg-[#1D95AD] px-4 md:flex">
              <PhoneIcon className="size-4 text-white" />
              <div className="flex items-center gap-1 transition-all duration-300 ease-in-out group-hover:opacity-0">
                <div className="ml-4 text-sm font-medium text-white">Nous appeler</div>
              </div>
              <div className="absolute top-0 left-6 flex h-full w-full items-center gap-2 px-4 py-2 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100">
                <div className="text-sm font-medium text-white">{agencyPhone}</div>
                <CopyIcon
                  className="hover:text-brand-600 size-4 cursor-pointer text-white transition-colors"
                  onClick={async () => {
                    await navigator.clipboard.writeText(agencyPhone)
                  }}
                />
              </div>
            </div>
          </>
        )}
        <Button
          className="h-10 bg-[#1D95AD] px-3 text-white hover:bg-[#167B90] md:px-4"
          onClick={() => {
            void navigate({ to: isAuthenticated && user ? '/' : '/login' })
          }}
          size="sm"
          type="button"
        >
          <UserRound className="size-4" />
          <span className="hidden md:inline">Mon espace</span>
        </Button>
      </div>
    </div>
  )
}
